"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _flat = _interopRequireDefault(require("flat"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _get2 = _interopRequireDefault(require("lodash/get"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Fortress = window.cccisd && window.cccisd.fortress;
var store = window.cccisd.store;
var _default = exports["default"] = function _default(queryVariables) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var variables = {};
  queryVariables.forEach(function (v) {
    if ('trainingOrg' in v && v.trainingOrg !== 0) {
      variables = v;
    }
    if ('value' in v) {
      variables[v.variable] = v.value;
    } else if ('from' in v && v.from === 'user') {
      variables[v.variable] = (0, _flat["default"])(Fortress)[v.field];
    } else if ('from' in v && v.from === 'redux') {
      variables[v.variable] = (0, _get2["default"])(store.getState(), v.field);
    } else if (!(0, _isEmpty2["default"])(data)) {
      variables[v.variable] = data[v.field];
    }
  });
  return variables;
};